/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from 'react'; // we need this to make JSX compile
import { Grid } from '@mui/material';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { checkIsBase64, clean, convertToPhoneDisplayFormat, getBrowserType, getOperatingSystem } from '../../Utils/CommonBaseClass';
import { SignUpFlow } from './SignUpFlow';
import { isUserLoggedIn, setKey } from '../../../libs/utils/storageManager';
import { pushGTM, setFullStoryEvents, useIsMobileOrTabletScreen, useIsMobileRotateScreen, useIsMobileScreen } from '../../../libs/utils/utils';
import { HeaderSignup } from './HeaderSignup';
import LeftPanelWithOverlay from './LeftPanelWithOverlay';
import { ReactComponent as ShieldSignupLeftpanel } from '../../../assets/svg/signup/shield-signup-leftpanel.svg';

import { ReactComponent as CashBuilderAccount } from '../../../assets/svg/signup/cash-builder-account.svg';
import { ReactComponent as DebitCard } from '../../../assets/svg/signup/debit-card.svg';
import { ReactComponent as PassThroughFDICInsuredAccount } from '../../../assets/svg/signup/pass-through-fdic-insured-account.svg';
import { ReactComponent as VendorPayment } from '../../../assets/svg/signup/vendor-payment.svg';

/**
 * This component loads the Signup Flow Home component
 */
export const SignUpFlowHome: React.FC = () => {

        // declaring params
        const params = useParams<any>();
        let searchParams = useLocation().search;
        // remove the gtm parameters if any
        if(searchParams.includes('&gtm_debug')){
            searchParams = searchParams.split('&gtm_debug')[0]
        }
        const isSmallScreen = useIsMobileRotateScreen();
        const queryParams = checkIsBase64(searchParams.substring(1))? window.atob(searchParams.substring(1)):searchParams.substring(1);
        const qParams = (new URLSearchParams(queryParams));
        const phoneNumber = (qParams.get('phone'));
        const countryCode = qParams.get('countryCode')
        const cType = qParams.get('type');
        const interestRate = qParams.get('interestRate');
        let email = qParams.get('email')+'';
        if(phoneNumber){
          setKey("invitationType","SMS")
          setKey("countryCode", countryCode);
        }else{
          setKey("invitationType","EMAIL")
        }
        //backend not encoded the params properly.
        //convert space to + for email
        email = email.replace(" ","+")

        //if already logged in do  not show this page
        const history = useHistory();

        if (isUserLoggedIn()) {
          window.location.replace('/');
          return null;
      }

        
        const inviteCode = params.token;
        // declaring source variables

        const details:any = {
            inviteCode: inviteCode,
            email: (email !== 'null' && email !== "")? email :'',
            phoneNumber: phoneNumber? convertToPhoneDisplayFormat(phoneNumber) :'',
            countryCode:countryCode,
            firstName: qParams.get('firstName')? qParams.get('firstName') : '',
            lastName: qParams.get('lastName')? qParams.get('lastName') : '',
            legalName: qParams.get('legalName')? qParams.get('legalName') : '',
            isPrimaryOwner : qParams.get('isPrimaryOwner')
        };
        if(cType &&  cType !== 'null') {details.type = cType }
        // configuring gtm for user signup launch page
            const gtmData ={
                event:"userInvitationTrigger",
                "userInvitationCode": inviteCode
            }
            pushGTM(gtmData)
            // configuring full story for user signup launch page
            setFullStoryEvents('userInvitationTrigger',{
                "userInvitationCode": inviteCode
              });
           /**
             * Session meta data are collected here
             */
            const navigatorDetails:any = navigator;
            const utmParam = {
                utmSource: qParams.get('utm_source'),
                utmMedium: qParams.get('utm_medium'),
                utmCampaign: qParams.get('utm_campaign'),
                utmContent: qParams.get('utm_content')
            }
            const sessionMetadata = {
                utm: utmParam,
                refererUrl: document.referrer,
                browser: getBrowserType(navigatorDetails['userAgent']),
                os: getOperatingSystem(navigatorDetails['userAgent']),
                browserCodeName: navigatorDetails['appCodeName'],
                browserName: navigatorDetails['appName'],
                browserVersion: navigatorDetails['appVersion'],
                cookiesEnabled: navigatorDetails['cookieEnabled'],
                browserLanguage: navigatorDetails['language'],
                browserOnline: navigatorDetails['onLine'],
                platform: navigatorDetails['platform'],
                userAgent: navigatorDetails['userAgent'],
            }
            
            const features = [
                {
                  icon: <PassThroughFDICInsuredAccount />,
                  title: "Passthrough FDIC Insured Account",
                  description:
                    "Pass-through FDIC insurance is subject to FDIC rules. See the Passport Account Agreement for details",
                },
                {
                  icon: <CashBuilderAccount />,
                  title: "Cash Builder Account",
                  description: `Turn your Cash into Opportunity with ${interestRate}% APY.`,
                },
                {
                  icon: <DebitCard />,
                  title: "Debit Card",
                  description:
                    "Enjoy the convenience of a debit card designed for you—secure, fast, and accepted everywhere you shop.",
                },
              ];
              
              // Conditionally add "Vendor Payments" if type is "business"
              if (details?.type === "BUSINESS") {
                features.push({
                  icon: <VendorPayment />,
                  title: "Vendor Payments",
                  description: "Online bill and recurring electronic payments.",
                });
              }
             
            return (
            <Grid item container xs={12}>
                {!isSmallScreen && <HeaderSignup percentage={40} logoutIconRequired={false} customerType={details?.type}/>}
                <Grid style={{ display: 'flex', flex: 1}} className='signup-flow-home-wrapper'>
                    {!isSmallScreen &&<LeftPanelWithOverlay type={details?.type} features={features} />}
                    <SignUpFlow key="signupflowhome" id="signup-flow-home-component" details={clean(details)} sessionMetadata={sessionMetadata}></SignUpFlow>
                </Grid>
                
            </Grid>

        )
    }